import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import FormDialog from '../../../components/ui/FormDialog'
import FormField, { FormGrid } from '../../../components/ui/FormField'
import type { DeadlineRequest } from '../types'

interface Props {
  /** İşlenecek talep; `null` → pop-up kapalı. */
  request: DeadlineRequest | null
  submitting: boolean
  onSubmit: (rejectNote: string) => void
  onHide: () => void
}

/**
 * **Talebi reddet** pop-up'ı (087/US3).
 *
 * <p>Açıklama **koşulsuz zorunludur** (FR-021) — yalnız boşluktan oluşan metin de kabul edilmez.
 * (Şemadaki kolon yorumu "Red sebebi DİĞER seçilmiş ise…" der ama bu tabloda ret **sebebi** için
 * picklist yoktur; yorum bilet talebinden kopyalanmıştır.)
 *
 * <p>Ret aksiyonun **hiçbir alanını** değiştirmez (FR-022).
 */
export default function RejectDialog({ request, submitting, onSubmit, onHide }: Readonly<Props>) {
  const { t } = useTranslation()
  const [note, setNote] = useState('')

  useEffect(() => {
    setNote('')
  }, [request])

  const invalid = note.trim() === ''

  const submit = () => {
    if (invalid || submitting) return
    onSubmit(note.trim())
  }

  return (
    <FormDialog
      visible={request != null}
      header={t('deadlineRequests.reject.title')}
      submitLabel={t('deadlineRequests.reject.submit')}
      submitting={submitting}
      submitDisabled={invalid}
      onSubmit={submit}
      onHide={onHide}
    >
      <FormGrid>
        {/* Aksiyon adı BAŞLIKTA değil formun içinde (kullanıcı kararı 2026-08-14) — onay pop-up'ıyla
            aynı düzen; hangi talebin reddedildiği başlığı şişirmeden görünür. */}
        <FormField
          label={t('deadlineRequests.field.actionName')}
          htmlFor="deadline-reject-action"
          full
        >
          <InputText
            id="deadline-reject-action"
            value={request?.actionName ?? ''}
            readOnly
            disabled
          />
        </FormField>

        <FormField
          label={t('deadlineRequests.reject.rejectNote')}
          htmlFor="deadline-reject-note"
          required
          full
        >
          <InputTextarea
            id="deadline-reject-note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={4}
            maxLength={4000}
            autoResize
          />
        </FormField>
      </FormGrid>
    </FormDialog>
  )
}
